// src/modules/app-views/services/pages/Init/components/tableColumns/nameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'service',
    dataIndex = 'name',
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => (
      <div className="d-flex" style={{ width }}>
        <span className="font-weight-semibold">{r?.name || '—'}</span>
      </div>
    ),
  };
}

export default nameColumn;
